import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mbToB',
})
export class MbToBPipe implements PipeTransform {
  transform(value: number): number {
    return value * (1024 * 1024);
  }
}
